import { Automation } from "services/admin/automationsService";
import AppTable from "components/AppTable/AppTable";
import { CircularProgress } from "@mui/material";
import { useGetAutomationContacts } from "hooks/useGetAutomationContacts";
import { toDate } from "helpers/dateHelper";
import { PlatformIcon } from "components/PlatformIcon/PlatformIcon";

interface AutomationContactsProps {
  automation: Automation;
}
export const AutomationContacts = ({ automation }: AutomationContactsProps) => {
  const { data, isLoading, error } = useGetAutomationContacts(automation.id);
  const columnConfig = [
    {
      key: "name",
      label: "Контакт",
      render: (automationRun: any) => {
        const contact = automationRun.contact || {};
        return (
          <div className="flex items-center gap-2">
            <img
              src={contact.externalUserPhoto}
              alt="User Photo"
              className="w-10 h-10 rounded-full"
            />
            <span>
              {contact.externalUserFirstName ||
                contact.externalUserUserName ||
                contact.externalUserID}
            </span>
          </div>
        );
      },
    },
    {
      key: "createdAt",
      label: "Дата запуска",
      formatter: (v: any) => toDate(v),
    },
  ];
  return (
    <div>
      {/* Account */}
      <div className="flex items-center gap-2 justify-center mb-4">
        <div>
          <PlatformIcon platform={automation.channelConnection?.source} size={24} />
        </div>
        <img
          style={{ width: "24px", height: "24px" }}
          src={automation.channelConnection?.externalAccountPhoto}
          alt={
            automation.channelConnection?.externalAccountUserName ||
            automation.channelConnection?.externalAccountID
          }
          className="w-8 h-8 rounded-full"
        />
        <span>
          {automation.channelConnection?.externalAccountUserName ||
            automation.channelConnection?.externalAccountID}
        </span>
      </div>
      <h3 className="text-2xl font-bold mb-8 text-center ">Аналитика по клиентам</h3>
      {isLoading ? (
        <div className="text-center">
          <CircularProgress size={20} />
        </div>
      ) : error ? (
        <div className="text-center">Error: {error.message}</div>
      ) : (
        <div>
          <AppTable data={data?.rows || []} columnConfig={columnConfig} />
        </div>
      )}
    </div>
  );
};
